<template>
  <b-input-group>
    <b-input-group-prepend is-text>
        <font-awesome-icon :icon="['fab', schema.network]"/>
    </b-input-group-prepend>
    <input
      class="form-control col-md-12"
      type="text"
      v-model="value"
      :disabled="disabled"
      :maxlength="schema.max"
      :placeholder="schema.placeholder"
      :readonly="schema.readonly"
    >
  </b-input-group>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';

library.add(faFacebook, faTwitter, faInstagram, faLinkedin);

export default {
  mixins: [abstractField],
};
</script>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldSocial.vue